export { ReactComponent as IconArrow } from './arrow.svg';
